import { jwtDecode } from 'jwt-decode';

/**
 * Thin wrapper around `jwt-decode` (Auth0, zero-dependency, ~150B gzip).
 *
 * Why this exists: `AccountInfo.idTokenClaims` (MSAL) only ever reflects the ID token's
 * claims. The ACCESS token (the one actually attached as `Authorization: Bearer` on API
 * calls, and the one you get from jwt.ms / jwt.io when copying it from DevTools) can carry
 * a DIFFERENT/additional set of claims (e.g. `roles`, `groups`, `scp`) depending on how the
 * Azure AD app registration's optional claims are configured per token type. Do not assume
 * both tokens carry the same claims — decode the token you actually need the claims from.
 */
export function decodeJwtPayload<T = Record<string, unknown>>(jwt: string | undefined | null): T | null {
	if (!jwt) {
		return null;
	}

	try {
		return jwtDecode<T>(jwt);
	} catch (err) {
		console.warn('[jwt.util] Failed to decode JWT payload:', err);
		return null;
	}
}

